import React from 'react'
import { useField } from 'formik'

import countries from 'constants/countries'
import { Select, SelectOption } from 'components/Select'
import Form from 'components/Form'

const countryList = Object.entries(countries)

interface CountryFieldProps {
  name: string
}

const CountryField: React.FC<CountryFieldProps> = ({ name }) => {
  const [field, meta, { setValue }] = useField({ name })

  return (
    <Form.Field
      id="country"
      label="Country"
      errorText={meta.touched ? meta.error : undefined}>
      <Select {...field} onChange={setValue}>
        {countryList.map(([countryCode, country]) => (
          <SelectOption key={countryCode} value={countryCode}>
            {country}
          </SelectOption>
        ))}
      </Select>
    </Form.Field>
  )
}

export default CountryField
